import { render, staticRenderFns } from "./Mantenedor_Areas.vue?vue&type=template&id=12252c2b&"
import script from "./Mantenedor_Areas.vue?vue&type=script&lang=js&"
export * from "./Mantenedor_Areas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports